import { createSlice } from '@reduxjs/toolkit';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { init_local_workspace_child_entity_child_viewer_delete } from './child_entity/local_workspace_child_entity_child_viewer_delete';
import { init_local_workspace_child_entity_child_viewer_delete_by_entity_data } from './child_entity/local_workspace_child_entity_child_viewer_delete_by_entity_data';
import { init_local_workspace_child_entity_child_viewer_upsert } from './child_entity/local_workspace_child_entity_child_viewer_update_status';
import { init_local_workspace_child_entity_set_current_viewed } from './child_entity/local_workspace_child_entity_set_current_viewed';
import { init_remote_workspace_child_entity_update_viewer_status } from './child_entity/remote_workspace_child_entity_update_viewer_status';
import { INIT_LOCAL__workspace__set_current } from './entity/LOCAL__workspace__set_current';
import { INIT_LOCAL__workspace_set_is_all_data_loaded } from './entity/LOCAL__workspace_set_is_all_data_loaded';
import { init_local_workspace_delete } from './entity/local_workspace_delete';
import { init_local_workspace_upsert } from './entity/local_workspace_upsert';
import { init_remote_workspace_create } from './entity/remote_workspace_create';
import { init_remote_workspace_update_avatar } from './entity/remote_workspace_update_avatar';
import { init_local_workspace_transfer_ownership_proposal_delete } from './ownership/local_workspace_transfer_ownership_proposal_delete';
import { init_local_workspace_transfer_ownership_proposal_upsert } from './ownership/local_workspace_transfer_ownership_proposal_upsert';
import { init_remote_workspace_transfer_ownership_proposal_create } from './ownership/remote_workspace_transfer_ownership_proposal_create';
import { init_remote_workspace_transfer_ownership_proposal_delete } from './ownership/remote_workspace_transfer_ownership_proposal_delete';
import { init_remote_workspace_transfer_ownership_proposal_reply } from './ownership/remote_workspace_transfer_ownership_proposal_reply';
import { STATE__workspace } from './STATE__workspace';
import { init_local_workspace_user_delete } from './user/local_workspace_user_delete';
import { init_local_workspace_user_upsert } from './user/local_workspace_user_upsert';
import { init_remote_workspace_user_credits_limit_reset } from './user/remote_workspace_user_credits_limit_reset';
import { init_remote_workspace_user_credits_limit_update } from './user/remote_workspace_user_credits_limit_update';
import { init_remote_workspace_user_credits_limit_update_status } from './user/remote_workspace_user_credits_limit_update_status';
import { init_remote_workspace_user_delete } from './user/remote_workspace_user_delete';
import { init_remote_workspace_user_update_permissions } from './user/remote_workspace_user_update_permissions';
import { init_local_workspace_user_invitation_delete } from './user_invitation/local_workspace_user_invitation_delete';
import { init_local_workspace_user_invitation_upsert } from './user_invitation/local_workspace_user_invitation_upsert';
import { init_remote_workspace_user_invitation_assign_to_user } from './user_invitation/remote_workspace_user_invitation_assign_to_user';
import { init_remote_workspace_user_invitation_create } from './user_invitation/remote_workspace_user_invitation_create';
import { init_remote_workspace_user_invitation_delete } from './user_invitation/remote_workspace_user_invitation_delete';
import { init_remote_workspace_user_invitation_reply } from './user_invitation/remote_workspace_user_invitation_reply';

const initialState: STATE__workspace = {
  workspace_current: DTO__workspace.CREATE_STUB(),
  current_workspace_user: DTO__workspace_user.CREATE_STUB(),
  current_viewed_entity: DTO__entity_with_grid2d.CREATE_STUB(),

  workspaces_map: new Map(),
  all_workspaces_users_map: new Map(),

  invitations_map_to_other_workspaces: new Map(),

  invitations_map_to_other_users: new Map(),

  child_entity_viewers_map: new Map(),

  transfer_ownership_proposals_map: new Map(),

  is_all_data_loaded: false,
};

const reducers: Record<string, any> = {};

export const slice_workspace = createSlice({
  name: ENUM__redux_slice.WORKSPACE,

  initialState,

  reducers: {
    ...reducers,
    workspace_upsert: init_local_workspace_upsert,
    workspace_delete: init_local_workspace_delete,

    workspace_user_upsert: init_local_workspace_user_upsert,
    workspace_user_delete: init_local_workspace_user_delete,

    workspace_user_invitation_upsert: init_local_workspace_user_invitation_upsert,
    workspace_user_invitation_delete: init_local_workspace_user_invitation_delete,

    set_current_viewed: init_local_workspace_child_entity_set_current_viewed,

    workspace_child_entity_viewer_upsert: init_local_workspace_child_entity_child_viewer_upsert,
    workspace_child_entity_viewer_delete: init_local_workspace_child_entity_child_viewer_delete,
    workspace_child_entity_viewer_delete_by_entity_data: init_local_workspace_child_entity_child_viewer_delete_by_entity_data,

    set_current: INIT_LOCAL__workspace__set_current,
    set_is_all_data_loaded: INIT_LOCAL__workspace_set_is_all_data_loaded,

    workspace_transfer_ownership_proposal_upsert: init_local_workspace_transfer_ownership_proposal_upsert,
    workspace_transfer_ownership_proposal_delete: init_local_workspace_transfer_ownership_proposal_delete,
  },

  extraReducers: builder => {
    init_remote_workspace_create(builder);

    init_remote_workspace_child_entity_update_viewer_status(builder);

    init_remote_workspace_user_delete(builder);
    init_remote_workspace_user_update_permissions(builder);
    init_remote_workspace_user_credits_limit_update(builder);
    init_remote_workspace_user_credits_limit_update_status(builder);
    init_remote_workspace_user_credits_limit_reset(builder);

    init_remote_workspace_user_invitation_assign_to_user(builder);
    init_remote_workspace_update_avatar(builder);

    init_remote_workspace_user_invitation_reply(builder);
    init_remote_workspace_user_invitation_delete(builder);
    init_remote_workspace_user_invitation_create(builder);

    init_remote_workspace_transfer_ownership_proposal_create(builder);
    init_remote_workspace_transfer_ownership_proposal_reply(builder);
    init_remote_workspace_transfer_ownership_proposal_delete(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialState;
    });
  },
});
